export default __webpack_public_path__ + "static/media/only_one.b10371a9.gif";